<!-- eslint-disable max-len -->
<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="form-wrap">
    <div class="form-group">
      <div class="form-item">
        <p
          style="margin-left: 0!important;"
          class="considerations-text c-color-caution">
          「ZULA」サービス利用規約（音楽配信許諾）の内容と注意事項をお読みいただき下記の同意をお願いします。<br />
          ※最後までスクロールしていただかないと、同意のチェックができません。
        </p>
        <div
          style="text-align: center"
          :class="{ 'apple': isAppleDevice }">
          <div
            class="agree-area"
            @scroll="onScrollAgreement">
            <div class="page-block__heading page-block__heading--withbar">
              <h3 class="page-block__title">「ZULA」サービス 利用規約（音楽配信許諾）</h3>
            </div>
            <div class="page-block__inner">
              <div class="terms-area">
                <div class="terms-text__box">
                  <p>
                    株式会社massenext（以下「当社」といいます）は、当社が提供する「ZULA」サービスの利用について、以下のとおり利用規約（以下「本規約」といいます。）を定めます。<br><br>
                    「ZULA」サービスをご利用される場合には、本規約をご確認、同意した上でご利用ください。<br>
                  </p>
                </div>

                <h4>第１条（本規約の目的）</h4>
                <div class="terms-text__box">
                  <p>
                    　本規約は、当社が提供する「ZULA」サービスを利用するにあたり必要な条件を定めることを目的とします。
                  </p>
                </div>

                <h4>第２条（「ZULA」サービスの利用契約）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>「ZULA」サービスの利用を希望する者（以下「申込者」といいます）は、本規約の内容を承諾の上、当社所定の方法により、「ZULA」サービスの利用登録の申込みをするものとします。</li>
                    <li>第１項の申込みを受けて当社が「ZULA」サービスの利用登録をした時に、申込者と当社の間で本規約を内容とする「ZULA」サービスの利用契約（以下「本契約」といいます）が成立するものとします。</li>
                  </ol>
                </div>

                <h4>第３条（定義）</h4>
                <div class="terms-text__box">
                  <p>
                    本規約において、以下の各用語は、次の定義に従い使用されるものとします。
                  </p>
                  <ul>
                    <li>(1)「音源ファイル」とは、契約者が原盤権又は管理権を有する楽曲のうち、本配信（以下に定義する）の対象として契約者及び当社が別途定める楽曲を収録した音源ファイルをいいます。</li>
                    <li>(2)「MV」とは、音源ファイルに収録された楽曲のミュージックビデオその他関連する動画を総称していいます。</li>
                    <li>(3)「配信サービス」とは、当社が選定する楽曲やミュージックビデオ等の配信を行うサービスをいいます。</li>
                    <li>(4)「配信サービス提供事業者」とは、配信サービスの提供を行う事業者をいいます。</li>
                    <li>(5)「本配信」とは、配信サービスの定める配信形態に応じて、音源ファイル及びMVを配信サービスにおいて、継続的に、全世界に対して（ただし、契約者及び当社間で協議のうえ、地域（国）を限定する場合がある）、自動公衆送信（配信サービスの利用促進を目的とした視聴用の無料配信を含む）及び送信可能化その他の公衆送信（ダウンロード、ストリーミングその他配信方法を問わない）をすることをいいます。</li>
                    <li>(6)「楽曲情報」とは、音源ファイルに収録された楽曲のジャケット写真、商品識別コード、プロダクトタイプ、音源の種類、アルバム名、アルバムのジャンル、リリース日（国内）、商標、アーティスト名、トラックナンバー、ISRC、楽曲名（英語表記含む）、楽曲の歌詞、楽曲秒数、楽曲ジャンル、アーティスト写真等の音源ファイルに関連する情報をいい、当社が本配信に必要なものとして指定する情報をいいます。</li>
                  </ul>
                </div>

                <h4>第４条（許諾等）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>契約者は当社に対し、本契約期間中、以下の各号に定める事項（以下、総称して「本許諾事項」という）を非独占的に許諾します。ただし、契約者は当社に対し、本契約終了後であっても、当社の実績宣伝のために、楽曲情報を利用することを非独占的に許諾します。</li>
                    <ul>
                      <li>(1)本配信</li>
                      <li>(2)本配信にあたり、配信サービスの配信条件等に合わせて音源ファイル及びMVを加工、翻訳、編集及び改変（デジタル変換し、記録媒体へ複製する行為等を含む）すること。</li>
                      <li>(3)本配信に必要な限りで、楽曲情報を無償で当社に提供し、本配信に必要な限りで加工、翻訳、編集及び改変（デジタル変換し、記録媒体へ複製する行為等を含む）のうえ、その全部又は一部を継続的に表示・配信すること。</li>
                      <li>(4)本配信を促進するため、楽曲情報の全部又は一部を第三者が提供するサービス上において継続的に表示・配信すること。</li>
                      <li>(5)本配信に必要な限りで、音源ファイル、MV及び楽曲情報の複製物を配信サービスのサーバー内に保管すること。</li>
                      <li>(6)当社が管理・運営するMUSICAGENTウェブサイト「ZULA.jp」において、音源ファイルに収録された楽曲の宣伝・広告活動（その楽曲情報をZULA.jpに掲載することを含む）を行うこと。</li>
                      <li>(7)本配信に関して各配信サービスで必要とされ又は推奨される音源ファイル、ＭＶ及び楽曲情報の管理に関する手続き（アカウントの作成、各音源ファイルのＩＤ登録すること等）を行うこと。</li>
                      <li>(8)前各号に定める他、契約者及び当社間で別途合意した事項。</li>
                    </ul>
                    <li>契約者は、当社に対して、当社の指定する仕様・方法に従って、音源ファイル、MV及び楽曲情報を供給するものとし、不備があった際には、これを是正するものとします。</li>
                    <li>当社は、配信サービス提供事業者に対し、必要に応じて本許諾事項を再許諾（再々許諾以降を含む。）する権利を有するものとします。</li>
                    <li>当社は、本配信を行う前に、当該本配信における配信サービスの概要（配信サービス提供事業者の名称、配信地域等）を契約者に通知するものとしますが、当社の通知後、５営業日以内に、書面又は電子メールにより、配信サービスの利用について異議を申し立てることができ、当該期間内に異議申し立てがない場合、契約者は、当該本配信を許諾したものとします。契約者が当社に対し当該異議を申し立てた場合、契約者及び当社は当該配信サービスの利用について誠実に協議を行うものとします。</li>
                    <li>契約者は、配信サービスの利用開始後であっても、合理的理由がある場合、当社に対し、当該配信サービスの利用に関し協議を求めることができます。</li>
                  </ol>
                </div>

                <h4>第５条（個別契約）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>本規約の各規定は、別途契約者及び当社間において締結される、音源ファイル、MV並びに楽曲情報の選定・追加、納品時期等を定める個々の契約（以下、「個別契約」という）にも適用されるものとしますが、個別契約で本規約と異なる定めをした場合、個別契約の規定が本規約の規定に優先して適用されるものとします。</li>
                    <li>個別契約は、当社から契約者に対し、本許諾事項の対象となる音源ファイル、MV及び楽曲情報等を申請（追加する場合を含む）し、契約者がこれを承諾したときに成立するものとします。</li>
                    <li>個別契約の申請及び成立は、別段の定めがある場合を除き、電子メールにより行うものとし、個別契約の成立時は、当社が契約者の承諾の電子メールの受信した時とします。</li>
                    <li>契約者は、音源ファイル、MV及び楽曲情報等の内容が配信サービスの配信条件に合致しない等の理由により、配信サービスにおいて、配信が承認されない場合があることを、予め承諾し、これについて当社に対し、補償等を求めないものとします。</li>
                  </ol>
                </div>

                <h4>第６条（音源ファイル等使用料）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>当社は契約者に対し、本許諾事項に関する許諾の対価（以下、「音源ファイル等使用料」という）を支払うものとします。</li>
                    <li>
                      音源ファイル等使用料は、当社が配信サービス提供事業者から支払いを受ける本配信に係る収入の総額（消費税込）（以下、「本配信収入」という）に、下記の料率の割合を乗じた金額に消費税を加えた金額とします。ただし、料率につき別途合意した場合には、それに従います。
                      <div class="center-text">記</div>
                      <div class="center-text">料率：８０％</div>
                      <div class="right-text">以上</div>
                    </li>
                    <li>当社は、契約者に対して、音源ファイル等使用料を算出するにあたり、毎月末日締めにて当月の配信数/配信形態の内訳、本配信収入及び楽曲ごとの配信数等の本配信収入の根拠となる資料を、当該締日の属する月の翌々月末日までに提示するものとします。ただし、資料提示時期については、契約者及び当社の別途協議に基づき、配信サービスごとに異なる定めをすることができるものとします。</li>
                    <li>音源ファイル等使用料は、毎月末日締め、当該締日の９０日後に、当社から契約者に対して支払われるものとします。ただし、当月に支払われる音源ファイル等使用料が金１０,０００円（消費税抜き）に満たない場合、当該音源ファイル等使用料の支払いは翌月に持ち越され、以後、同様とします。また、支払い時期については、契約者及び当社の別途協議に基づき、配信サービスごとに異なる定めをすることができるものとします。</li>
                    <li>音源ファイル使用料の支払方法については、契約者が指定する金融機関口座に振込みによるものとします。ただし、振込みに係る費用は、当社の負担とします。</li>
                    <li>当社は、当社の責めに帰すべき事由によらず、当社が配信サービス提供事業者から本配信収入を受領できない場合、当社はこれを取り立て・回収する義務を負わず、かつ、契約者に対して、受領できなかった本配信収入に基づく音源ファイル等使用料を支払う義務を免れるものとします。ただし、当社は、当社が配信サービス提供事業者から本配信収入を受領できないことを知った場合、速やかにその旨を契約者に対して報告するとともに、その受領に向けて契約者と協力するものとします。</li>
                    <li>契約者は音源ファイル等使用料の支払先又は文書の送付先を変更する場合、書面又は電子メールを以て遅滞なく当社に通知するものとします。契約者より２年以上にわたり変更通知がないために、当社から契約者に対する支払い又は第３項に定める資料の提示が事実上不可能となった場合には、当社の支払い義務は免除されるものとします。</li>
                    <li>第４項ただし書により音源ファイル等使用料の支払いが留保されている場合であっても、契約者は、契約者が振込手数料を負担することを条件として、当社に対し、当該音源ファイル等使用料の支払いを求めることができます。</li>
                  </ol>
                </div>

                <h4>第７条（保証等）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>契約者は、本契約を締結し、本契約に基づく義務を履行するに必要かつ充分な資格と権能を有すること、並びに本契約の締結及び本契約に基づく義務の履行が法令及び契約者が第三者と締結する契約等に抵触せず、その違反又は債務不履行を構成しないこと、したがって、音源ファイル及びMVに収録された楽曲の実演を行った全ての実演家、楽曲情報の権利者その他如何なる第三者からも現在及び将来にわたり何等異議の申し立て等（第三者の著作権、著作隣接権、著作人格権、実演家人格権、商標権、不正競争防止法上の権利、氏名権、肖像権、パブリシティ権に関するものを含むがこれらに限られない）のないことを当社に保証します。当該保証事項が真実でなかった又は不正確であったことに起因して、万一、第三者との間に紛争が生じた場合は、契約者は自己の責任と負担においてこれを解決し、当社に一切迷惑をかけないものとします。また、この場合、当社は、当該紛争が解決し、又は、解決する見込みが高いと当社が判断するまでの間、音源ファイル、MV又は楽曲情報の本配信を含む利用の停止、中止その他必要と認める措置をとることができるものとします。</li>
                    <li>契約者は、音源ファイルに収録された楽曲の全てが著作権管理団体（JASRAC、NexTone）により管理されていること若しくは音楽著作権者と直接契約が締結されていることを当社に保証します。なお、本契約に基づく当社の音源ファイルの使用に関して、所有者／管理者（例えば、実演家、著作権管理団体）に支払われるべき全ての料金、ロイヤルティーその他の料金については、配信サービス提供事業者によって支払われるものとします。</li>
                    <li>契約者及び当社は、当社が契約者に対して、本規約第４条に定める音源ファイル等利用料の支払以外、何らの支払義務を生じないことを確認します。ただし、契約者及び当社間の本契約違反、及び解除に基づく損害賠償請求権の存在を否定するものではない。</li>
                    <li>本条第１項又は第２項に起因して第三者からの異議がなされた場合には、当社は本契約に基づき契約者に支払うべき対価の全部又は一部の支払いを留保し、紛争解決後に精算することができるものとします。</li>
                    <li>契約者及び当社は、音源ファイルに収録された楽曲において本配信に必要となる権利処理等（著作権登録、ISRC登録を含むがこれらに限られない）がなされていない場合、本条第１項から第４項の定めにかかわらず、契約者は当社に対して当該楽曲の権利処理等を委託することができます。なお、契約者及び当社別途協議のうえ、詳細を決定するものとします。</li>
                    <li>契約者は、いかなる手法においても、自ら又は第三者をして、音源ファイル及びMVの使用回数を不正に増やすことその他の不正再生行為を行ってはなりません。なお、契約者が本項の定めに違反し、当社が第三者から損害賠償請求その他の金銭請求を受け損害を被った場合、契約者は当社に対し、当該損害を賠償するものとします。</li>
                  </ol>
                </div>

                <h4>第８条（契約期間）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>本契約の有効期間は、申込日から３年間とします。</li>
                    <li>前項の有効期間後の契約の更新について、契約者及び当社は、有効期間満了日までに条件等の協議を行うものとし、本契約期間終了日の２ヶ月間までに一方当事者が相手方に対して書面により更新を拒絶する旨の通知をしなかった場合には、別段の合意がない限り、本契約は期間満了の日より自動的に同一条件にて１年間継続するものとし、以後、同様とします。</li>
                    <li>本契約の終了は、その原因の如何にかかわらず、本契約期間中に各当事者が本契約に基づき取得した権利には何らの影響を及ぼさないものとします。</li>
                    <li>本契約が終了した場合において、第４条４項ただし書に基づき音源ファイル等使用料の支払いが留保されているときは、契約者は、当社に対し、当該音源ファイル等使用料の支払いを求めることができます。この場合、当該音源ファイル等使用料の金額が振込手数料以下のときには、振込手数料は契約者の負担とし、振込手数料を超えるときには当社の負担とします。</li>
                    <li>本契約が終了した場合において、契約者が前項に基づき音源ファイル等使用料の支払いを請求しないときは、契約者及び当社は、当該音源ファイル等使用料の支払義務の免除について協議するものとします。</li>
                  </ol>
                </div>

                <h4>第９条（規約違反）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>契約者又は当社が、故意、過失により本規約に違反した場合には、違反者は当該違反により相手方が直接かつ現実に受けた通常損害を賠償する義務を負います。</li>
                    <li>前項による違反の場合、相手方は違反者に対し期限を定めて催告の上本契約を解除することができます。</li>
                  </ol>
                </div>

                <h4>第１０条（契約の解除）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>契約者又は当社は、相手方が本規約の各条項に違反した場合、相当の期間を定めて履行を催告し、その期間内に履行がないときは、本契約を解除することができるものとします。</li>
                    <li>契約者又は当社に次の各号の一に該当する事由が生じたときは、相手方は何ら催告を要さず、直ちに本契約の全部又は一部を解除することができます。</li>
                    <ul>
                      <li>(1)本規約の規定に違反し、当該違反の性質又は状況に照らし、違反を是正してもなお本規約の目的を達成することが困難であるとき。</li>
                      <li>(2)監督官庁より営業の取消、停止等の処分を受けたとき。</li>
                      <li>(3)本規約の履行に際して著しい背信行為があったとき。</li>
                      <li>(4)仮差押、差押、仮処分、競売、破産、民事再生手続開始、会社更生手続開始、会社整理、特別清算の申立てをし、又は申立てがなされたとき。</li>
                      <li>(5)支払不能、支払停止又は手形交換所の取引停止処分があったとき。</li>
                      <li>(6)公租公課の滞納処分を受けたとき。</li>
                      <li>(7)財産状態が悪化し、又はそのおそれがあると認められる相当の事由があるとき。</li>
                      <li>(8)その他、本規約を継続し難い重大な事由があるとき。</li>
                    </ul>
                    <li>契約者及び当社は、自己に前項各号のいずれかに該当する事由が生じたときは、当然に期限の利益を失い、相手方に対して負担する一切の債務を直ちに弁済するものとします。</li>
                    <li>本条の規定は、解除した当事者による損害賠償請求を妨げないものとします。</li>
                  </ol>
                </div>

                <h4>第１１条（機密保持）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>契約者及び当社は、本契約の遂行中に開示された相手方の営業、技術等に係る情報のうち、機密として保護すべき旨が明示された情報（次の各号に定める情報を除き、以下、「機密情報」という）を機密として保持し、善良なる管理者の注意義務をもってこれを管理するものとし、相手方の書面による承諾なくして第三者（再利用許諾権利者を除く）に対して漏洩又は開示してはなりません。なお、以下本条において、機密情報を開示した当事者を「開示者」といい、受領した当事者を「受領者」といいます。</li>
                    <ul>
                      <li>(1)開示される以前から保持していた情報</li>
                      <li>(2)開示された時点で公知であった情報</li>
                      <li>(3)開示された以後受領者の責めによらず公知となった情報</li>
                      <li>(4)開示者に対し秘密保持義務を負わない正当な権限を持つ第三者より正当に取得した情報</li>
                      <li>(5)機密情報に依拠することなく独自に開発又は生成した情報</li>
                    </ul>
                    <li>前項の規定に関わらず、管轄官公庁、裁判所または捜査機関等の公的機関が、受領者に対し、法令に基づき機密情報の開示を要請した場合、受領者は必要最小限度の機密情報を開示することができます。</li>
                    <li>受領者は、本契約に基づく権利行使又は義務履行に必要な範囲では、機密情報について必要最小限度の複製をすることができるが、複製された情報も機密情報とみなす。</li>
                    <li>受領者は、機密情報の使用に際し、当該機密情報を知る必要のある役員又は従業員に対してのみ当該機密情報を開示するものとし、当該役員又は従業員に対して、本規約に基づき受領者が負う義務と同等の守秘義務を課すものとします。</li>
                    <li>受領者は、本契約の終了時又は開示者から求められた場合にはいつでも、遅滞なく、開示者の指示に従い、機密情報ならびに機密情報を記載または包含した書面、その他の記録媒体及びその全ての複製物を返却又は廃棄するものとします。</li>
                    <li>本条の規定に違反して相手方に損害を与えた場合、違反当事者は相手方に対してその損害を賠償する責を負います。</li>
                  </ol>
                </div>

                <h4>第１２条（反社会的勢力の排除）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>契約者及び当社は、自己又は自己の代理人若しくは媒介をする者が、現在、暴力団、暴力団員、暴力団員でなくなったときから5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下総称して「暴力団員等」といいます）に該当しないこと、及び次の各号の何れにも該当しないことを表明し、且つ将来にわたっても該当しないことを相互に確約します。</li>
                    <ul>
                      <li>(1)暴力団員等が経営を支配していると認められる関係を有すること。</li>
                      <li>(2)暴力団員等が経営に実質的に関与していると認められる関係を有すること。</li>
                      <li>(3)自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に暴力団員等を利用していると認められる関係を有すること。</li>
                      <li>(4)暴力団員等に対して資金等を提供し、又は便宜を供与するなどの関与をしていると認められる関係を有すること。</li>
                      <li>(5)役員又は経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること。</li>
                    </ul>
                    <li>契約者又は当社は、前項の確約に反して、相手方又は相手方の代理若しくは媒介をする者が暴力団員等若しくは前項各号の一にでも該当することが判明したときは、何等の催告をせず、通知の上、本契約を解除することができるものとします。</li>
                    <li>契約者又は当社が、本規約に関連して、第三者と下請又は委託契約等（以下、「関連契約」という）を締結する場合又は締結している場合において、関連契約の当事者又は代理若しくは媒介をする者が暴力団員等若しくは本条第1項各号の一にでも該当することが判明したとき、他方当事者は、関連契約を締結した当事者に対して、関連契約を解除するなど必要な措置をとるよう求めることができるものとします。</li>
                    <li>契約者又は当社が、関連契約を締結した当事者に対して前項の措置を求めたにも拘らず、関連契約を締結した当事者がそれに従わなかった場合には、その相手方当事者は本契約を解除することができるものとします。</li>
                  </ol>
                </div>

                <h4>第１３条（権利義務の譲渡禁止）</h4>
                <div class="terms-text__box">
                  <p>
                    　契約者及び当社は、本契約から生じる権利義務の一切について、相手方の事前の書面による承諾なしにこれを第三者に貸与若しくは譲渡し、又は担保の用に供してはなりません。
                  </p>
                </div>

                <h4>第１４条（存続条項）</h4>
                <div class="terms-text__box">
                  <p>
                    　本規約第４条（許諾等）第1項ただし書き、第７条（保証等）、第８条（契約期間）第２項乃至４項、第９条（規約違反）第１項、第１０条（契約の解除）第２項及び第３項、並びに第１１条（機密保持）乃至第1５条（協議他）の規定は、本契約の終了又は満了後も存続します。
                  </p>
                </div>

                <h4>第１５条（協議他）</h4>
                <div class="terms-text__box">
                  <ol class="numbered">
                    <li>契約者及び当社は、本規約に定めのない事項又は本規約の各条項の解釈上に疑義が生じた場合は、法令の定めによるほか、誠意をもって協議し、その解決にあたるものとします。</li>
                    <li>本規約の準拠法は日本法とし、本規約に関する紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
                  </ol>
                </div>

                <h4>第１６条（「ZULA」サービスの終了）</h4>
                <div class="terms-text__box">
                  <p>
                    　当社は、「ZULA」サービスの提供を終了することがあります。この場合、当社は、その３か月前までに契約者にその旨及び終了日を通知するものとします。
                  </p>
                </div>

                <h4>第１７条（通知）</h4>
                <div class="terms-text__box">
                  <p>
                    　当社から契約者への通知は、契約者が「ZULA」サービスの利用契約の申込時に当社に届け出た電子メールアドレスその他の連絡先に宛てて発し、その通知が通常到達すべきであった時に到達したものとみなします。
                  </p>
                </div>

                <h4>第１８条（本規約の変更）</h4>
                <div class="terms-text__box">
                  <p>
                    　当社は、民法５４８条の４の規定により本規約を変更することができます。本規約を変更する場合、当社は、当社のウェブサイトにて本規約を変更する旨及び変更後の本規約の内容並びにその効力発生時期を告知します。
                  </p>
                </div>

                <p>2025年6月1日　制定</p>
                <p class="right-text">以上</p>
              </div>
            </div>
          </div>
        </div>
        <div class="consent-checkbox-area">
          <div class="checkbox">
            <label>
              <input
                v-model="cplus_music_consent_agreed"
                :value="1"
                :disabled="!read_agreement"
                type="checkbox"
                @change="onChangeCheckbox">
              <div
                class="option-input"
                :style="{ 'opacity': read_agreement ? '100%' : '30%' }">
              </div>
              「ZULA」サービス利用規約（音楽配信許諾）の内容と注意事項を理解・同意しました
            </label>
          </div>
        </div>
        <!-- <p
          v-if="errors._restrictions_0_invalid_youtube_monetize"
          class="error-text">
          {{ errors._restrictions_0_invalid_youtube_monetize[0] }}
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CplusMusicConcentForm',
  data() {
    return {
      read_agreement: false,
      cplus_music_consent_agreed: false,
    }
  },
  computed: {
    isAppleDevice() {
      return window.navigator.userAgent.indexOf('iPhone') !== -1
        || window.navigator.userAgent.indexOf('iPad') !== -1
        || window.navigator.userAgent.indexOf('Mac') !== -1
    },
  },
  methods: {
    onScrollAgreement(event) {
      if (!this.read_agreement) {
        if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 20) {
          this.read_agreement = true
        }
      }
    },
    onChangeCheckbox() {
      this.$emit('change-cplus_music_consent_agreed', this.cplus_music_consent_agreed)
    },
  },
}
</script>

<style scoped>
.agree-area {
  width: 100%;
  height: 300px;
  overflow-y: scroll;
  border: 1px inset #808080;
  background-color: white;
  margin: auto auto;
  padding: 5px 2px 5px 2px;
  text-align: left;
}

.agree-area A {
  text-decoration: underline;
}

.agree-area A:hover {
  text-decoration: none;
}

.asterisk {
  color: #ff4b6d;
  font-weight: bold;
}
.apple ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
}

.apple ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}
.disabled{
  opacity: 0.5;
}
ol.numbered{
  margin-left: 1.2em;
  & > li{
    list-style: decimal;
  }
}
.center-text {
  text-align: center;
}

.right-text {
  text-align: right;
}
</style>
